import { LoggerService } from '@lx/shared/logger';

export interface ClassTimeMixinDeps {
  loggerService: LoggerService;
}

export function withProccessedClassTime<T extends ClassTimeMixinDeps>({ loggerService }: T, classTime: string) {
  if (!classTime) {
    return null;
  }

  // If the class time is invalid, log the error and return
  if (classTime.length < 4) {
    loggerService.error(`Invalid class time: ${classTime}`);
    return null;
  }

  return `${classTime.substring(0, 2)}:${classTime.substring(2, 4)}`;
}
